// src/oura/components/docs/create/RenameToHouse.tsx
//
// Rename (B16, scope 2.6): under the doc drawer's "In the decided format"
// preview, one click renames the file to the house format the preview shows.
// It sends the previewed name, so what the server writes is what the preview
// says (the server refuses a name off the house format). Only the file name
// changes: nothing in the doc's body is touched. Renders nothing unless
// DOCS_WRITE_ON.

import { useState } from "react";
import { PencilLineIcon } from "lucide-react";
import { DOCS_WRITE_ON, renameDocument } from "@service/aeo/clientDocsWrite";
import { cn } from "../../../lib/cn";
import { LATE_TEXT, PillButton, TYPE } from "@oura/ui";
import { docsFailureText } from "@oura/docs";

export function RenameToHouse({
    documentId,
    name,
    onBusy,
    onRenamed,
}: {
    documentId: string;
    name: string;
    onBusy?: (busy: boolean) => void;
    /** Said in the sheet's foot: this button goes once the name matches. */
    onRenamed?: (text: string) => void;
}) {
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState<string | null>(null);
    if (!DOCS_WRITE_ON) return null;

    const rename = async () => {
        if (busy) return;
        setBusy(true);
        onBusy?.(true);
        setError(null);
        const r = await renameDocument(documentId, { name });
        setBusy(false);
        onBusy?.(false);
        if (r.ok) onRenamed?.("Renamed to the house format.");
        else setError(r.reason === "network" ? "The name did not change. Try again." : docsFailureText(r, "this document"));
    };

    return (
        <div className="mt-2">
            <PillButton size="sm" icon={PencilLineIcon} busy={busy} onClick={() => void rename()}>
                Rename to this
            </PillButton>
            {error && (
                <p role="alert" className={cn(TYPE.tc, LATE_TEXT, "m-0 mt-2")}>
                    {error}
                </p>
            )}
        </div>
    );
}
